import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from "reactstrap";
import Swal from "sweetalert2";
import { formatMoney } from '../../utils/NumberFormat';

let clickArr = []
export function showAlertt() {
    Swal.fire({
        title: `Sonuç`,
        html: `<div className="row"> 
        <div className="col-xs-4"> Numune Sayısı: <strong>${clickArr.length}</strong></div> 
        <div className="col-xs-4"> Ortalama: <strong>${formatMoney(average(clickArr), "2", ",", ".")}</strong> </div> 
        <div className="col-xs-4"> Standart Sapma: <strong>${formatMoney(standardDeviation(clickArr), "4", ",", ".")}</strong> </div> 
        <div className="col-xs-4"> Toplam: <strong>${formatMoney(total(clickArr), "2", ",", ".")}</strong> </div> 
        </div>`,
        icon: faLayerGroup,
        confirmButtonText: "Tamam",
    });
}
export const calculatorFunc = (props) => {
    if (props.rowType === "header" || props.rowType === "filter") {
        clickArr = []
    }
    else if (props.rowIndex >= 0) {
        if (document.querySelectorAll('.dx-data-row')[props.rowIndex] !== undefined) {
            var elements = document.querySelectorAll('.dx-data-row')[props.rowIndex].children
            if (typeof props.displayValue === "number") {
                if (elements.item(props.columnIndex).classList.contains("selected-column")) {
                    elements.item(props.columnIndex).classList.remove("selected-column")
                    if (clickArr.indexOf(props.displayValue) !== -1) {
                        clickArr.splice(clickArr.indexOf(props.displayValue), 1);
                    }
                } else {
                    elements.item(props.columnIndex).classList.add("selected-column")
                    clickArr.push(props.displayValue)
                }
            }
        }
    }
}
export function standardDeviation(arr, usePopulation = false) {
    const mean = arr.reduce((acc, val) => acc + val, 0) / arr.length;
    return Math.sqrt(
        arr.reduce((acc, val) => acc.concat((val - mean) ** 2), []).reduce((acc, val) => acc + val, 0) /
        (arr.length - (usePopulation ? 0 : 1))
    );
}
export function average(selectedValue) {
    let toplam = 0;
    let arr = []
    if (selectedValue !== undefined && selectedValue !== null) {
        selectedValue.forEach((item) => {
            toplam = toplam + item;
            arr.push(item);
        });
    }

    return toplam / selectedValue.length
}
function total(arr) {
    var total = 0;
    for (var i = 0; i < arr.length; i++) {
        if (Number(arr[i])) {
            total += arr[i];
        }
    }
    return total;
}

export function clearSelect() {
    clickArr = []
    var element = document.querySelectorAll(".selected-column")
    for (let i = 0; i < element.length; i++) {
        element[i].classList.remove("selected-column")
    }
}
export default function CalculatorButton() {

    const intl = useIntl();
    const getFormatMessage = (messageKey) => {
        return intl.formatMessage({ id: messageKey, defaultMessage: messageKey });
    }

    return (
        <>
            <span title={getFormatMessage("mrpButton.hesapla")}>
                <Button className='btn-warning mr-1'
                    style={{ padding: "6px 10px", cursor: "pointer" }}
                    onClick={showAlertt}
                >
                    <i className="fa fa-calculator" aria-hidden="true"></i>
                </Button>
            </span>

            <span title={getFormatMessage("mrpButton.temizle")}>
                <Button className='btn-warning mr-1'
                    style={{ padding: "6px 10px", cursor: "pointer" }}
                    onClick={clearSelect}
                >
                    <i className="fa fa-trash" aria-hidden="true"></i>
                </Button>
            </span>
        </>
    )
}